import {AudioExtension, AudioFileContentType, NonAudioExtension, NonAudioFileContentType} from './types'

export const MEDIA_BYTE_SIZE_LIMIT = 4 * 1024 * 1024 * 1024

export const contentType = (ext: NonAudioExtension): NonAudioFileContentType => {
  switch (ext) {
    case 'note':
    case 'ntb':
      return 'application/zip'
    case 'pdf':
      return 'application/pdf'
    case 'png':
    case 'jpg':
    case 'image':
    case 'gif':
      return 'application/octet-stream' as const
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Unknown content type: ${ext}`)
  }
}

export const audioContentType = (ext: AudioExtension): AudioFileContentType => {
  switch (ext) {
    case 'm4a':
    case 'wav':
    case 'mp4':
    case 'webm':
      return `audio/${ext}` as const
    case 'weba':
      return `audio/webm`
    case 'mp3':
      return 'audio/mpeg'
    default:
      throw new Error(`Unknown content type: ${ext}`)
  }
}
